import styled from 'styled-components'
import { deviceMax } from '../../theme/breakpoints'
import pxToRem from '../../utils/pxToRem'
import Slider from 'react-slick'

import SliderPrevArrow from '../../images/icons/clients-arrow-left.svg'
import SliderNextArrow from '../../images/icons/clients-arrow-right.svg'
import theme from '../../theme/theme-style'

export const StyledClientsBanner = styled.div`
  z-index: 2;
  align-items: center;
  flex-direction: column;
  flex-wrap: wrap;
  display: flex;
  margin: auto;
  width: 100%;
  padding: ${pxToRem(30)} ${pxToRem(48)};
  background-color: ${({ theme }) => theme.colors.unique.white};

  @media ${deviceMax.mobileL} {
    padding: ${pxToRem(30)} 0;
  }
`

export const StyledClientsList = styled(Slider)`
  margin-top: ${pxToRem(32)};
  width: 100%;

  & .slick-list {
    margin: 0 ${pxToRem(25)};
  }

  & .slick-track {
    align-items: center;
    display: flex;
    justify-content: ${(client) =>
      client.length >= 4 ? null : 'space-between'};
    gap: ${pxToRem(50)};
  }

  & .slick-prev,
  .slick-next {
    z-index: 98;

    :hover {
      border-radius: ${pxToRem(50)};
      box-shadow: ${({ theme }) => theme.boxShadows.overlay};
      background-color: ${({ theme }) => theme.colors.unique.white};
    }
  }

  & .slick-prev {
    left: 0;
  }

  & .slick-next {
    right: 0;
  }
`
export const StyledClientContainer = styled.div`
  overflow: visible;
  position: relative;
  margin: 0;
`

export const StyledClientLink = styled.a`
  overflow: visible;
  justify-content: center;
  display: flex;

  video,
  img {
    object-fit: contain;
    width: fit-content;
    height: ${pxToRem(80)};
  }
`

export const StyledPrevArrow = styled(SliderPrevArrow)`
  width: ${pxToRem(40)};
  height: ${pxToRem(40)};
`

export const StyledNextArrow = styled(SliderNextArrow)`
  width: ${pxToRem(40)};
  height: ${pxToRem(40)};
`

export const StyledHoverText = styled.p.attrs((props) => ({
  style: {
    position: 'absolute',
    zIndex: 2,
    left: pxToRem(props.$offsetX),
    top: pxToRem(props.$offsetY),
    borderRadius: pxToRem(5),
    padding: pxToRem(5),
    boxShadow: theme.boxShadows.overlay,
    backgroundColor: theme.colors.unique.white,
  },
}))``

export const StyledLegalNotice = styled.p`
  margin: ${pxToRem(10)} ${pxToRem(120)} 0 ${pxToRem(120)};
  color: ${({ theme }) => theme.colors.custom.battleshipGrey};
  font-size: ${({ theme }) => theme.fonts.sizes.sm};
  font-weight: ${({ theme }) => theme.fonts.weight.normal};
  line-height: ${({ theme }) => theme.fonts.lineHeight.sm};
  text-align: center;
  @media ${deviceMax.mobileL} {
    margin: ${pxToRem(10)} ${pxToRem(20)} 0 ${pxToRem(20)};
  }
`
